import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function AdminRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) return null; // wait for localStorage to load

  if (!user) return <Navigate to="/" replace />;
  
  if (user.role !== 'admin' && user.role !== 'moderator') {
    return <Navigate to="/swipe" replace />;
  }

  return children;
}